import { ReactNode, useCallback, useContext, useMemo, useState } from 'react';
import { assertIsDefined, assertIsDefinedAndNullable } from '@/helpers/assertions';
import { HeaderContext } from '@/providers/HeaderContextProvider/HeaderContextProvider';
import { IHeaderContext } from '@/providers/HeaderContextProvider/HeaderContextProvider.types';

export const useHeaderManager = () => {
  const [node, setNode] = useState<ReactNode | null>(null);
  const [visible, setVisible] = useState(false);

  const show = useCallback(() => setVisible(true), []);
  const hide = useCallback(() => setVisible(false), []);

  const value: IHeaderContext = useMemo(
    () => ({
      node,
      visible,
      setNode,
      show,
      hide,
    }),
    [node, visible, setNode, show, hide],
  );

  return value;
};

export const useHeader = () => {
  const { node, visible, setNode, show, hide } = useContext(HeaderContext);

  assertIsDefinedAndNullable(node, '"IHeaderContext.node has to be defined!"');
  assertIsDefined(visible, '"IHeaderContext.visible has to be defined!"');
  assertIsDefined(setNode, '"IHeaderContext.setNode has to be defined!"');
  assertIsDefined(show, '"IHeaderContext.show has to be defined!"');
  assertIsDefined(hide, '"IHeaderContext.hide has to be defined!"');

  return { node, visible, setNode, show, hide };
};
